import { render, staticRenderFns } from "./user-avatar-manage.vue?vue&type=template&id=0b3412da&scoped=true&"
import script from "./user-avatar-manage.vue?vue&type=script&lang=js&"
export * from "./user-avatar-manage.vue?vue&type=script&lang=js&"
import style0 from "./user-avatar-manage.vue?vue&type=style&index=0&id=0b3412da&lang=less&scoped=true&"
import style1 from "./user-avatar-manage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3412da",
  null
  
)

export default component.exports